import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=6cb67092&scoped=true"
import script from "./billing.vue?vue&type=script&lang=js"
export * from "./billing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb67092",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb67092')) {
      api.createRecord('6cb67092', component.options)
    } else {
      api.reload('6cb67092', component.options)
    }
    module.hot.accept("./billing.vue?vue&type=template&id=6cb67092&scoped=true", function () {
      api.rerender('6cb67092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/billing.vue"
export default component.exports